import React, { useEffect, useState, useContext, useRef } from "react";
import Papa from "papaparse";
import axios from "axios";
import editIcon from "../../assets/Home/editIcon.svg";
import trashIcon from "../../assets/Home/trashIcon.svg";
import { NemuContext } from "../../utils/NemuContext";
import Modal from "../ModelModal";
// import { RModal } from "../RModal";
// import { EditList } from "./EditList";
import PropertyEditModal from "../EditPropiertyModal/ModalPropierty";
import Swal from "sweetalert2";

const api = process.env.REACT_APP_API_URL;

const AddCSV = ({ onClick, properties, setProperties, models, setModels, type, onUserChange }) => {
  const [modalAbierto, setModalAbierto] = useState(false);
  const [selectedModelId, setSelectedModelId] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [sortConfig, setSortConfig] = React.useState({
    key: null,
    direction: null,
  });
  const [editingCell, setEditingCell] = useState(null); // { rowIndex, field }
  const [editingValue, setEditingValue] = useState("");

  const modelsBackupRef = useRef([]);    // Guarda modelos antes de borrar
  const csvJustImportedRef = useRef(false); // Flag para saber si el cambio fue por CSV

  const handleEditClick = (property) => {
    if(property.key === undefined || property.key === null){
      Swal.fire({
        icon: "info",
        title: "Atención",
        text: "Guarda cambios del desarrollo para poder editar la propiedad",
        showConfirmButton: true,
      });
      return;
    }
    setSelectedProperty(property);
    setIsEditModalOpen(true);
  };

  const handleDeleteClick = (id) => {
    Swal.fire({
      title: `¿Estás seguro de eliminar este registro ${id}?`,
      text: "No podrás revertir esta acción",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        setProperties(properties.filter((element) => element.key !== id));
        onUserChange?.();
        Swal.fire("Eliminado", "El registro ha sido eliminado", "success");
      }
    });
  };
  
  // const [properties, setproperties] = useState([]);
  // const [apiproperties, setApiproperties] = useState([]);
  // const [apiModels, setApiModels] = useState([]);
  const [showpropertiesModal, setShowpropertiesModal] = useState(false);
  // const [models, setModels] = useState([]);
  const [modelsCount, setModelsCount] = useState([]);
  const { selectedProp } = useContext(NemuContext);

  useEffect(() => {
    // console.log(selectedModelId);
  }, [selectedModelId]);

  useEffect(() => {
    // fetchDevelopment();
    // setApiproperties([]);
  }, [selectedProp]);

  

  // --- Inline editing (Excel-like) ---
  const editableColumns = [
    { key: "propertie_id", label: "ID", inputType: "text" },
    { key: "floor", label: "Piso", inputType: "number" },
    { key: "model", label: "Modelo", inputType: "text" },
    { key: "rooms_number", label: "Habitaciones", inputType: "number", hideFor: ["Local", "Bodega", "Terreno"] },
    { key: "bathrooms_number", label: "Baños", inputType: "number" },
    { key: "parking_places", label: "Cajones", inputType: "number" },
    { key: "building_surface", label: "Construcción", inputType: "number", suffix: "m²" },
    { key: "terrace_surface", label: "Terraza", inputType: "number", suffix: "m²", hideFor: ["Local", "Bodega", "Terreno"] },
    { key: "total_surface", label: "m2 Totales", inputType: "number", suffix: "m²" },
    { key: "orientation", label: "Orientación", inputType: "text" },
    { key: "list_price", label: "Precio", inputType: "number", format: "currency" },
    { key: "status", label: "Estado", inputType: "select", options: ["Disponible", "Apartado", "Vendido"] },
    { key: "type", label: "Tipo", inputType: "select", options: type === "Departamento" ? ["departamento", "penthouse", "studio"] : type === "Pool de Rentas" ? ["departamento", "penthouse", "studio"] : type === "Casa" ? ["casa"] : type === "Local" ? ["local"] : type === "Terreno" ? ["terreno"] : ["bodega"] },
  ];

  const visibleColumns = editableColumns.filter(
    (col) => !col.hideFor || !col.hideFor.includes(type)
  );
  const visibleFields = visibleColumns.map((col) => col.key);

  const handleCellClick = (rowIndex, field, currentValue) => {
    setEditingCell({ rowIndex, field });
    setEditingValue(currentValue != null ? String(currentValue) : "");
  };

  const commitEdit = () => {
    if (!editingCell) return;
    const { rowIndex, field } = editingCell;
    const sortedElement = sortedproperties[rowIndex];
    const realIndex = properties.findIndex((p) => p === sortedElement);
    if (realIndex !== -1) {
      const updated = [...properties];
      updated[realIndex] = { ...updated[realIndex], [field]: editingValue };
      setProperties(updated);
      onUserChange?.();
    }
    setEditingCell(null);
    setEditingValue("");
  };

  const cancelEdit = () => {
    setEditingCell(null);
    setEditingValue("");
  };

  const handleCellKeyDown = (e, rowIndex) => {
    if (e.key === "Enter") {
      commitEdit();
    } else if (e.key === "Escape") {
      cancelEdit();
    } else if (e.key === "Tab") {
      e.preventDefault();
      const currentFieldIndex = visibleFields.indexOf(editingCell.field);
      const nextIndex = currentFieldIndex + (e.shiftKey ? -1 : 1);
      // Save current edit first
      if (editingCell) {
        const sortedElement = sortedproperties[editingCell.rowIndex];
        const realIndex = properties.findIndex((p) => p === sortedElement);
        if (realIndex !== -1) {
          const updated = [...properties];
          updated[realIndex] = { ...updated[realIndex], [editingCell.field]: editingValue };
          setProperties(updated);
          onUserChange?.();
        }
      }
      if (nextIndex >= 0 && nextIndex < visibleFields.length) {
        const nextField = visibleFields[nextIndex];
        const val = sortedproperties[rowIndex][nextField];
        setEditingCell({ rowIndex, field: nextField });
        setEditingValue(val != null ? String(val) : "");
      } else {
        setEditingCell(null);
        setEditingValue("");
      }
    }
  };

  const renderEditableCell = (element, rowIndex, col) => {
    const isEditing = editingCell?.rowIndex === rowIndex && editingCell?.field === col.key;
    const rawValue = element[col.key];

    if (isEditing) {
      if (col.inputType === "select") {
        return (
          <select
            autoFocus
            value={editingValue}
            onChange={(e) => setEditingValue(e.target.value)}
            onBlur={commitEdit}
            onKeyDown={(e) => handleCellKeyDown(e, rowIndex)}
            className="w-full bg-white border border-nemu-azul rounded px-1 py-0.5 text-[12px] outline-none"
          >
            {col.options.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        );
      }
      return (
        <input
          autoFocus
          type={col.inputType}
          value={editingValue}
          onChange={(e) => setEditingValue(e.target.value)}
          onBlur={commitEdit}
          onKeyDown={(e) => handleCellKeyDown(e, rowIndex)}
          className="w-full bg-white border border-nemu-azul rounded px-1 py-0.5 text-[12px] outline-none"
        />
      );
    }

    // Read mode — special rendering for status and currency
    if (col.key === "status") {
      return (
        <div
          onClick={() => handleCellClick(rowIndex, col.key, rawValue)}
          className="cursor-pointer hover:bg-nemu-platino rounded px-1 py-0.5 min-h-[24px]"
        >
          <div className="flex gap-1 items-center">
            <div
              style={{
                backgroundColor: getStatusColor(rawValue),
                color: rawValue === "Apartado" ? "black" : "white",
              }}
              className="w-2 h-2 rounded-full"
            />
            <span>{rawValue}</span>
          </div>
        </div>
      );
    }

    let displayValue = rawValue;
    if (col.format === "currency" && rawValue != null) {
      displayValue = formatCurrency(rawValue);
    } else if (col.suffix && rawValue != null) {
      displayValue = `${rawValue}${col.suffix}`;
    }

    return (
      <div
        onClick={() => handleCellClick(rowIndex, col.key, rawValue)}
        className="cursor-pointer hover:bg-nemu-platino rounded px-1 py-0.5 min-h-[24px]"
      >
        {col.key === "type" ? <span className="capitalize">{displayValue}</span> : displayValue}
      </div>
    );
  };

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const sortedproperties = [...properties].sort((a, b) => {
    const aValue =
      sortConfig.key &&
      typeof a[sortConfig.key] === "string" &&
      !isNaN(a[sortConfig.key])
        ? parseInt(a[sortConfig.key], 10)
        : a[sortConfig.key];
    const bValue =
      sortConfig.key &&
      typeof b[sortConfig.key] === "string" &&
      !isNaN(b[sortConfig.key])
        ? parseInt(b[sortConfig.key], 10)
        : b[sortConfig.key];

    if (aValue < bValue) {
      return sortConfig.direction === "ascending" ? -1 : 1;
    }
    if (aValue > bValue) {
      return sortConfig.direction === "ascending" ? 1 : -1;
    }
    return 0;
  });

  // const sortedApiproperties = [...apiproperties].sort((a, b) => {
  //   const aValue =
  //     sortConfig.key &&
  //     typeof a[sortConfig.key] === "string" &&
  //     !isNaN(a[sortConfig.key])
  //       ? parseInt(a[sortConfig.key], 10)
  //       : a[sortConfig.key];
  //   const bValue =
  //     sortConfig.key &&
  //     typeof b[sortConfig.key] === "string" &&
  //     !isNaN(b[sortConfig.key])
  //       ? parseInt(b[sortConfig.key], 10)
  //       : b[sortConfig.key];

  //   if (aValue < bValue) {
  //     return sortConfig.direction === "ascending" ? -1 : 1;
  //   }
  //   if (aValue > bValue) {
  //     return sortConfig.direction === "ascending" ? 1 : -1;
  //   }
  //   return 0;
  // });

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          console.log(results.data);
          const developments = results.data.map((row, index) => ({
            key: row.key !== '' ? row.key : null,
            propertie_id: row.clave,
            floor: row.piso,
            orientation: row.orientacion,
            // description: row.description,
            // type: row.type,
            // images_path: row.images_path,
            list_price: row.precio_lista,
            // first_payment: row.first_payment,
            // monthly_payment: row.monthly_payment,
            rooms_number: row.recamaras,
            bathrooms_number: row.banios,
            parking_places: row.cajones,
            building_surface: row.construccion,
            terrace_surface: row.terraza,
            balcony_surface: row.balcon,
            warehouse_surface: row.bodega,
            total_surface: row.m2_totales,
            status: row.estado,
            model: row.modelo,
            type: type === 'Departamento' ? row.tipo : type === 'Pool de Rentas' ? row.tipo : type === 'Casa' ? 'casa' : type === 'Local' ? 'local' : type === 'Terreno' ? 'terreno' : 'bodega',
            development_id: selectedProp, // Use the selectedProp context value if needed
          }));

          csvJustImportedRef.current = true;
          setProperties(developments);
          onUserChange?.();
        },
      });
    }
  };

  // const handleFileUpload = () => {
  //   if (properties.length === 0) {
  //     alert(
  //       "No hay registros para subir. Por favor, selecciona un archivo CSV."
  //     );
  //     return;
  //   }

  //   const modelsWithDevelopmentId = models.map((model) => ({
  //     ...model,
  //     development_id: selectedProp,
  //   }));

  //   axios
  //     .post(`${api}/propertie/add`, {
  //       properties: properties,
  //       models: modelsWithDevelopmentId,
  //       development_id: selectedProp,
  //     })
  //     .then((response) => {
  //       console.log("Registros subidos con éxito:", response);
  //       Swal.fire("¡Listo!", "Los registros han sido subidos con éxito", "success");
  //       const newElemetsWithKey = response.data.result.newProperties.map((element, index) => ({
  //         ...element,
  //         key: element.id,
  //       }));
  //       setProperties(newElemetsWithKey);
  //       setModels(response.data.result.newModels);
  //     })
  //     .catch((error) => {
  //       console.error("Error al subir los registros:", error.message);
  //       alert("Hubo un error al subir los registros.");
  //     });
  // };

  const getStatusColor = (status) => {
    if (status === "Disponible"){
      return "#4C63ED";
    } else if (status === "Apartado") {
      return "#E4DE1E";
    } else if (status === "Vendido") {
      return "#129B12";
    } else {
      return "#C1C1C1";
    }
  };

  const formatCurrency = (number) => {
    return `$${number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
  };

  // useEffect(() => {
  //   const updatedModels = {...models};
    
  //   for (const model of updatedModels) {
  //     model.availability = properties.filter((element) => element.model === model.name && element.status === "Disponible").length;
  //     model.count = properties.filter((element) => element.model === model.name).length;
  //   }

  //   setModels(updatedModels);

  //   // setModelCount(
  //   //   properties.reduce((acc, element) => {
  //   //     acc[element.model] = (acc[element.model] || 0) + 1;
  //   //     return acc;
  //   //   }, {})
  //   // );
  //   // setModels(modelCount);
    
  // }, [properties]);

  // useEffect(() => {
  //   // Creamos una copia de los modelos
  //   console.log(models);
    
  //   const updatedModels = { ...models };
  
  //   // Iteramos sobre las claves y valores de updatedModels
  //   for (const [modelName, model] of Object.entries(updatedModels)) {
  //     // Actualizamos la disponibilidad
  //     model.availability = properties.filter((element) => element.model === modelName && element.status === "Disponible").length;
  //     // Actualizamos la cantidad total de elementos para cada modelo
  //     model.count = properties.filter((element) => element.model === modelName).length;
  //   }
  
  //   // Actualizamos el estado de los modelos
  //   console.log(updatedModels);
    
  //   setModels(updatedModels);
  // }, [models, properties]); // Asegúrate de que 'properties' esté como dependencia si cambia.

  useEffect(() => {
    if (properties.length !== 0) {
      const count = properties.reduce((acc, element) => {
        if (!acc[element.model]) {
          acc[element.model] = { count: 0, availability: 0 };
        }
        acc[element.model].count += 1;
        acc[element.model].availability +=
          element.status === "Disponible" ? 1 : 0;
        return acc;
      }, {});

      setModelsCount(count);

      const updatedModels = Object.keys(count).map((name) => {
        const existing =
          models.find((m) => m.name === name) ||
          modelsBackupRef.current.find((m) => m.name === name);
        return {
          id: existing?.id || "",
          key: name,
          name,
          main_image: existing?.main_image || "",
          blueprints: existing?.blueprints || "",
          availability: count[name].availability,
        };
      });

      // Si fue una reimportación CSV y hay backup, mostrar resumen de cambios
      if (csvJustImportedRef.current && modelsBackupRef.current.length > 0) {
        csvJustImportedRef.current = false;

        const backupNames = modelsBackupRef.current.map((m) => m.name);
        const newNames = Object.keys(count);

        const conservados = newNames.filter((n) => backupNames.includes(n));
        const nuevos = newNames.filter((n) => !backupNames.includes(n));
        const eliminados = backupNames.filter((n) => !newNames.includes(n));

        let html = "";
        if (conservados.length > 0) {
          html += `<p><b>Conservados (${conservados.length}):</b> ${conservados.join(", ")}</p>`;
        }
        if (nuevos.length > 0) {
          html += `<p style="color:green"><b>Nuevos (${nuevos.length}):</b> ${nuevos.join(", ")}</p>`;
        }
        if (eliminados.length > 0) {
          html += `<p style="color:red"><b>Eliminados (${eliminados.length}):</b> ${eliminados.join(", ")}</p>`;
        }

        Swal.fire({
          icon: "info",
          title: "Resumen de modelos",
          html,
          showConfirmButton: true,
        });
      } else {
        csvJustImportedRef.current = false;
      }

      setModels(updatedModels);
    } else {
      // Al limpiar propiedades, guardar backup de modelos actuales
      if (models.length > 0) {
        modelsBackupRef.current = models;
      }
      setModels([]);
      setModelsCount({});
    }
  }, [properties]);

  // Mantener backup sincronizado cuando los modelos se actualizan (ej. carga inicial del API)
  useEffect(() => {
    if (models.length > 0) {
      modelsBackupRef.current = models;
    }
  }, [models]);

  const handleDeleteList = () => {
    Swal.fire({
      title: "¿Estás seguro de eliminar la lista?",
      text: "No podrás revertir esta acción",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        setProperties([]);
        onUserChange?.();
        Swal.fire("¡Listo!", "La lista ha sido eliminada", "success");
      }
    });
  }

  const handleAddProperty = () => {
    const newProperty = {
      key: null,
      propertie_id: "",
      floor: 1,
      orientation: "",
      list_price: 0,
      rooms_number: 0,
      bathrooms_number: 0,
      parking_places: 0,
      building_surface: 0,
      terrace_surface: 0,
      balcony_surface: 0,
      warehouse_surface: 0,
      total_surface: 0,
      status: "Disponible",
      model: "",
      type: type === "Departamento" ? "departamento" : type === "Pool de Rentas" ? "departamento" : type === "Casa" ? "casa" : type === "Local" ? "local" : type === "Terreno" ? "terreno" : "bodega",
      development_id: selectedProp,
    };
    setProperties([...properties, newProperty]);
    onUserChange?.();

    // Enfocar la primera celda de la nueva fila después del render
    setTimeout(() => {
      const tableContainer = document.querySelector(".overflow-y-auto table");
      if (tableContainer) {
        const scrollContainer = tableContainer.closest(".overflow-y-auto");
        if (scrollContainer) {
          scrollContainer.scrollTop = scrollContainer.scrollHeight;
        }
      }
    }, 100);
  };

  const handleDownloadPropertiesCSV = () => {
    const mapToCSVFormat = (property) => (type === 'Departamento' || type === 'Casa' || type === 'Pool de Rentas') ? ({
      key: property.key || '',
      clave: property.propertie_id || '',
      piso: property.floor || 1,
      orientacion: property.orientation || '',
      precio_lista: property.list_price || '',
      recamaras: property.rooms_number || 0,
      banios: property.bathrooms_number || 0,
      cajones: property.parking_places || 0,
      construccion: property.building_surface || 0,
      terraza: property.terrace_surface || 0,
      balcon: property.balcony_surface || 0,
      bodega: property.warehouse_surface || 0,
      m2_totales: property.total_surface || 0,
      estado: property.status || 'Disponible',
      modelo: property.model || '',
      tipo: property.type || 'departamento',
    })
    : 
    ({
      key: property.key || '',
      clave: property.propertie_id || '',
      piso: property.floor || 1,
      orientacion: property.orientation || '',
      precio_lista: property.list_price || '',
      banios: property.bathrooms_number || 0,
      cajones: property.parking_places || 0,
      construccion: property.building_surface || 0,
      bodega: property.warehouse_surface || 0,
      m2_totales: property.total_surface || 0,
      estado: property.status || 'Disponible',
      modelo: property.model || '',
      tipo: property.type,
    });
    const csvData = properties.map(mapToCSVFormat);
    const csv = Papa.unparse(csvData, { header: true });
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "lista_propiedades.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  const fetchEditModel = async (model) => {
    console.log("Model ID:", model.id);
    if(model.id !== ''){
      setModalAbierto(true);
      setSelectedModelId(model);
    }else{
      Swal.fire({
        icon: "info",
        title: "Atención",
        text: "Guarda cambios del desarrollo para poder modificar el modelo",
        showConfirmButton: true,
      });
    }
    
    // try {
    //   const response = await axios.get(`${api}/development/modelExists/${modelId}`);
    //   if(response.data.success){
    //     setModalAbierto(true);
    //     setSelectedModelId(modelId);
    //   }
    //   else{
    //     Swal.fire({
    //       icon: "info",
    //       title: "Atención",
    //       text: "Guarda cambios del desarrollo para poder modificar el modelo",
    //       showConfirmButton: true,
    //     });
    //   }
    // } catch (error) {
    //   console.error("Error al verificar el modelo:", error);
    //   return false;
      
    // }
  }

  return (
    <div className="flex flex-col w-full gap-2 h-full justify-center z-20">
      {modalAbierto && (
        <Modal
          model={selectedModelId}
          setModels={setModels}
          onClick={() => setModalAbierto(false)}
        />
      )}
      <h1 className="font-medium text-[20px]" onClick={() => console.log(properties)}>Listado de propiedades</h1>
      {isEditModalOpen && (
        <PropertyEditModal
          propertyId={selectedProperty?.key}
          propertyData={selectedProperty}
          setProperties={setProperties}
          type={type}
          onClose={(updatedData) => {
            setIsEditModalOpen(false);
            // Handle the updated data if needed, like refreshing the property list
          }}
        />
      )}
      {properties.length === 0 ? (
        <>
          <div className="flex justify-between">
            <p className="text-[16px] font-normal">
              Usa tus archivos excel para importar el listado de tus
              desarrollos.{" "}
            </p>
            <p className="text-[16px] font-normal">Peso máximo: 1 MB</p>
          </div>
          <label className="flex flex-col h-full w-full border-2 border-dashed border-nemu-black items-center justify-center py-12 rounded-lg cursor-pointer hover:bg-gray-300 transition">
            <p className="w-full text-center mt-2 text-nemu-black text-[20px]">
              Drop your file here, or
              <span className="text-nemu-azul cursor-pointer hover:underline">
                {" "}
                browse.
              </span>
            </p>
            <span className="text-[12px]">Supports: CSV</span>
            <input
              className="hidden"
              type="file"
              accept=".csv"
              onChange={handleFileChange}
            />
          </label>
        </>
      ) : (
        <></>
      )}

      {properties.length > 0 && (
        <>  
          <div className="flex justify-between">
            <p className="text-[16px] font-normal">
              Lista de todos los departamentos del proyecto.{" "}
            </p>
            <div className="flex items-center gap-2 text-red-500 font-medium  cursor-pointer hover:scale-105" onClick={() => handleDeleteList()}>
              <img src={trashIcon} alt="Recycle" />
              <span className="text-[16px]">Borrar Lista</span>
            </div>
          </div>
          <div className="overflow-x-auto overflow-y-auto max-h-[400px] w-full mt-3 px-3 rounded-md border-[1px] border-nemu-plata">
            <table className="table-auto w-full">
              <thead className="sticky top-0 bg-white z-10 bg-nemu-platino w-full h-12">
                <tr>
                  {visibleColumns.map((col) => (
                    <th
                      key={col.key}
                      onClick={() => handleSort(col.key)}
                      className={`border-b border-nemu-plata py-1 text-[12px] text-left font-medium cursor-pointer ${sortConfig.key === col.key ? "text-nemu-azul" : ""}`}
                    >
                      {`${col.label} ${
                        sortConfig.key === col.key
                          ? sortConfig.direction === "ascending"
                            ? "▲"
                            : "▼"
                          : ""
                      }`}
                    </th>
                  ))}
                  <th className="border-b border-nemu-plata py-1 text-[12px] text-left font-medium">
                    Acciones
                  </th>
                </tr>
              </thead>

              <tbody>
                {sortedproperties.map((element, index) => (
                  <tr key={index}>
                    {visibleColumns.map((col) => (
                      <td key={col.key} className="py-2 border-b border-nemu-plata text-[12px]">
                        {renderEditableCell(element, index, col)}
                      </td>
                    ))}
                    <td className="py-2 border-b border-nemu-plata">
                      <div className="flex gap-2 items-center">
                        <img
                          onClick={() => handleEditClick(element)}
                          className="w-6 cursor-pointer hover:scale-110"
                          src={editIcon}
                          alt="Edit"
                        />
                        <img
                          onClick={() => handleDeleteClick(element.key)}
                          className="w-6 cursor-pointer hover:scale-110"
                          src={trashIcon}
                          alt="Delete"
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex justify-between items-center mt-4">
            <div className="flex w-max pr-2 gap-1 cursor-pointer hover:scale-105" onClick={() => handleAddProperty()}>
              <svg className="w-[20px] h-[20px]" viewBox="0 0 24 24" fill="none" stroke="#4C63ED" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              <p className="text-[16px] text-nemu-azul font-400">Agregar propiedad</p>
            </div>
            <div className="flex w-max pr-2 gap-1 cursor-pointer hover:scale-105" onClick={() => handleDownloadPropertiesCSV()}>
              <img
                src={editIcon}
                alt="edit"
                className="w-[20px] h-[20px] cursor-pointer"
                style={{
                  filter:
                    "invert(35%) sepia(65%) saturate(4587%) hue-rotate(224deg) brightness(100%) contrast(87%)",
                }}
              />
              <p className="text-[16px] text-nemu-azul font-400">Descargar CSV</p>
            </div>
          </div>
          <h1 onClick={() => console.log("Models: ", models)} className="font-medium text-[20px]">Listado de modelos</h1>
          <p className="text-[16px] font-normal">
            Lista de todos los departamentos del proyecto.{" "}
          </p>
          <div className="overflow-x-auto overflow-y-auto max-h-[400px] w-full mt-4">
            <table className="table-auto w-full">
              <thead className="bg-gray-100">
                <tr>
                  <th className="py-1 border-b border-nemu-plata text-[11px] text-left font-normal">
                    Nombre
                  </th>
                  <th className="py-1 border-b border-nemu-plata text-[11px] text-left font-normal">
                    Unidades
                  </th>
                  <th className="py-1 border-b border-nemu-plata text-[11px] text-left font-normal">
                    Imagen de portada
                  </th>
                  <th className="py-1 border-b border-nemu-plata text-[11px] text-left font-normal">
                    Planos
                  </th>
                  <th className="py-1 border-b border-nemu-plata text-[11px] text-left font-normal">
                    Disponibilidad
                  </th>
                  <th className="py-1 border-b border-nemu-plata text-[11px] text-left font-normal">
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                {models.map((model) => (
                  <tr key={model.key}>
                    <td className="px-2 py-2 border-b border-nemu-plata">
                      {model.name}
                    </td>
                    <td className="px-2 py-2 border-b border-nemu-plata">
                      {modelsCount[model.name]?.count} / {properties.length}
                    </td>
                    <td className="px-2 py-2 border-b border-nemu-plata">
                      {model.main_image || "-"}
                    </td>
                    <td className="px-2 py-2 border-b border-nemu-plata">
                      {model.blueprints || "-"}
                    </td>
                    <td className="px-2 py-2 border-b border-nemu-plata">
                      {modelsCount[model.name]?.availability} / {modelsCount[model.name]?.count}
                    </td>
                    <td className="px-2 py-2 border-b border-nemu-plata">
                      <div
                      
                      className="flex gap-2 items-center">
                        <img
                          onClick={() => fetchEditModel(model)}
                          className="w-6 cursor-pointer hover:scale-110"
                          src={editIcon}
                          style={{
                            filter:
                              "invert(35%) sepia(65%) saturate(4587%) hue-rotate(224deg) brightness(100%) contrast(87%)",
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
                {/* {Object.entries(models).map(
                  ([model, { count, availability }]) => (
                    <tr key={count}>
                      <td className="px-2 py-2 border-b border-nemu-plata">
                        {model.name}
                      </td>
                      <td className="px-2 py-2 border-b border-nemu-plata">
                        {count} / {properties.length}
                      </td>
                      <td className="px-2 py-2 border-b border-nemu-plata">
                        -
                      </td>
                      <td className="px-2 py-2 border-b border-nemu-plata">
                        -
                      </td>
                      <td className="px-2 py-2 border-b border-nemu-plata">
                        {availability} / {count}
                      </td>
                      <td className="px-2 py-2 border-b border-nemu-plata">
                        <div
                        
                        className="flex gap-2 items-center">
                          <img
                            onClick={() => {
                              console.log("XDDDD");
                              setModalAbierto(true);
                              setSelectedModelId(model.key);
                            }}
                            className="w-6 cursor-pointer hover:scale-110"
                            src={editIcon}
                            style={{
                              filter:
                                "invert(35%) sepia(65%) saturate(4587%) hue-rotate(224deg) brightness(100%) contrast(87%)",
                            }}
                          />
                          <img
                            className="w-6 cursor-pointer hover:scale-110"
                            src={trashIcon}
                          />
                        </div>
                      </td>
                    </tr>
                  )
                )} */}
              </tbody>
            </table>
          </div>
          {/* <div className="flex w-full mt-4 gap-1">
            <img
              src={editIcon}
              alt="edit"
              className="w-[20px] h-[20px] cursor-pointer"
              onClick={onClick}
              style={{
                filter:
                  "invert(35%) sepia(65%) saturate(4587%) hue-rotate(224deg) brightness(100%) contrast(87%)",
              }}
            />
            <p className="text-[16px] text-nemu-azul font-400">Editar lista</p>
          </div> */}
        </>
      )}
      {/* <div className="flex w-full justify-start gap-[10px] mt-4">
        <div
          onClick={() => setproperties([])}
          className="flex h-[40px] items-center justify-center cursor-pointer border border-nemu-black px-4 py-2 rounded"
        >
          Cancelar
        </div>
        <div
          onClick={handleFileUpload}
          className="flex h-[40px] items-center justify-center cursor-pointer bg-nemu-azul text-white px-4 py-2 rounded"
        >
          Guardar
        </div>
      </div> */}
    </div>
  );
};

export { AddCSV };
